export default "/images/vendor/flag-icons/flags/1x1/cx.svg?37843d5d0d2c289e8bfe92e7f1b3ad84";